/**
 * Os atalhos da área de trabalho do Modo PC — F138.
 *
 * Poucos, e escolhidos pelo que NÃO atropelam. As telas já usam:
 *
 * - PDV: F1 a F10, `+`, `-`, Esc;
 * - Caixa: F2, F3, F4;
 * - recebimento: F2, F10, Alt+1 a Alt+9;
 * - editor de etiqueta: setas, Delete, Esc.
 *
 * Então nada de F10 para a barra de menus (é a entrega no PDV), nada de Alt com
 * número, e nada de Ctrl+W, Ctrl+N ou Ctrl+T, que o WebView ou o navegador
 * podem tomar para si. Sobram os de sempre de ERP de janelas:
 *
 * - **Ctrl+Tab** e **Ctrl+Shift+Tab**: alternar entre as janelas;
 * - **Ctrl+F4**: fechar a janela da frente;
 * - **Ctrl+K**: ir para uma tela (Shift+Enter na busca abre outra janela).
 *
 * Função pura: a tecla vira um comando, e quem executa é a área de trabalho.
 */

export type DesktopCommand =
  | { readonly kind: 'cycle'; readonly direction: 1 | -1 }
  | { readonly kind: 'closeActive' }
  | { readonly kind: 'search' }

export type ShortcutKey = Pick<
  KeyboardEvent,
  'key' | 'ctrlKey' | 'metaKey' | 'shiftKey' | 'altKey'
>

export const desktopCommandFor = (
  event: ShortcutKey
): DesktopCommand | null => {
  const modifier = event.ctrlKey || event.metaKey
  if (!modifier || event.altKey) return null

  if (event.key === 'Tab') {
    return { kind: 'cycle', direction: event.shiftKey ? -1 : 1 }
  }
  if (event.key === 'F4') return { kind: 'closeActive' }
  if (event.key.toLowerCase() === 'k' && !event.shiftKey) {
    return { kind: 'search' }
  }

  return null
}

/** A lista que o menu Ajuda mostra — a mesma que o código obedece. */
export const DESKTOP_SHORTCUTS: readonly {
  readonly keys: string
  readonly does: string
}[] = [
  { keys: 'Ctrl K', does: 'Ir para uma tela' },
  { keys: 'Shift+Enter na busca', does: 'Abrir a tela em outra janela' },
  { keys: 'Shift+clique', does: 'Abrir outra janela da mesma tela' },
  { keys: 'Ctrl Tab', does: 'Ir para a janela usada antes' },
  { keys: 'Ctrl Shift Tab', does: 'Ir para a janela mais antiga' },
  { keys: 'Ctrl F4', does: 'Fechar a janela da frente' },
  { keys: 'Duplo clique no título', does: 'Maximizar ou restaurar' },
]
